<ng-template appLabelInflatorContainer></ng-template>
